<template>
    <div class="navigation-menu" :data-language="interfaceLanguage">

        <div class="navigation-header">
            <svg @click="home" width="27" height="24" viewBox="0 0 27 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12.6592 0.488281V3.52699L21.7975 8.91921L12.6592 14.3412V17.3501L26.8905 8.91921L12.6592 0.488281Z" fill="#2C3143"/>
                <path d="M2.56105 13.2687V2.00764L0 0.488281V17.797L12.6597 10.2896V7.28069L2.56105 13.2687Z" fill="#2C3143"/>
            </svg>
            <transition name="fade">
                <svg @click="home" v-if="open" width="97" height="24" viewBox="0 0 97 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M96.079 3.37947H92.9635L92.9626 15.1402H90.2616L90.2625 3.37947L87.1461 3.37849V1.00577H96.08L96.079 3.37947ZM80.6325 6.42494C81.7133 6.80684 82.7297 7.18777 83.4364 7.8468C84.0595 8.41869 84.6191 9.37248 84.6182 10.8139C84.6172 13.5686 82.6633 15.4536 79.796 15.4516C77.2411 15.4507 75.7468 13.8604 75.0199 12.7793L76.7872 11.0636C77.4517 12.4414 78.7171 12.9506 79.694 12.9506C80.92 12.9526 81.8344 12.1898 81.8354 11.0039C81.8354 10.4947 81.6691 10.0912 81.297 9.73088C80.7767 9.24321 79.946 8.96707 79.1565 8.69092C78.4296 8.43631 77.5565 8.09749 76.8507 7.46098C76.3949 7.05851 75.7516 6.27315 75.7516 4.8317C75.7526 2.75569 77.1247 0.679685 80.1998 0.680664C81.0719 0.681644 82.7133 0.853012 84.1249 2.33657L82.7114 4.22163C81.9018 3.11899 80.946 3.01323 80.4479 3.01225C78.994 3.01128 78.5354 3.9445 78.5354 4.66523C78.5354 5.00307 78.6392 5.32132 78.9709 5.61902C79.3027 5.93629 79.7594 6.1057 80.6325 6.42494ZM68.4736 15.1334L68.4755 0.99892H71.1756L71.1746 15.1334H68.4736ZM57.6465 15.1471L51.8271 1.01263H54.7772L58.4753 10.5064L62.1725 1.01165H65.1226L59.2667 15.1471H57.6465ZM42.7837 15.4526C41.0596 15.4517 39.274 15.0903 37.7576 13.5411C37.2797 13.0554 35.7027 11.2732 35.7047 8.09553C35.7066 5.36049 36.9114 3.68696 37.7432 2.83991C38.7826 1.7598 40.5278 0.679685 43.2077 0.681644C44.2462 0.682623 45.3472 0.853012 46.4059 1.42587C47.3001 1.89199 48.2751 2.741 49.0021 4.01207L46.6539 5.30468C46.177 4.34991 45.4703 3.86224 45.0347 3.6282C44.452 3.33149 43.725 3.18264 43.0808 3.18264C41.9808 3.18166 40.7336 3.58414 39.8807 4.43119C39.0922 5.21459 38.4884 6.56987 38.4874 8.16016C38.4865 10.0452 39.2759 11.1704 39.8567 11.7423C40.4798 12.3572 41.4567 12.9516 42.9308 12.9516C43.8452 12.9526 44.8837 12.699 45.653 12.1056C46.1924 11.6825 46.7337 10.9628 46.9626 9.94533L43.3894 9.94338L43.3914 7.5687L49.7473 7.5736V7.74202C49.7473 8.69679 49.6213 11.6629 47.7078 13.5911C46.2741 15.0521 44.5087 15.4536 42.7837 15.4526ZM30.4853 15.1324L22.6563 6.12822L22.6573 15.1344L19.9572 15.1334L19.9582 0.99892H21.8284L29.6555 9.98059V0.996962H32.3565L32.3546 15.1334L30.4853 15.1324ZM12.6917 0.99892H15.3917V15.1334H12.6917V0.99892ZM0.880859 0.988148L3.58188 0.987169L3.58764 12.5247L8.74352 12.5266V15.1236H0.888555L0.880859 0.988148Z" fill="#2C3143"/>
                </svg>
            </transition>
            <svg @click="togglePinned" :class="{ 'pinned': pinned }" v-if="open && !isMobile" class="pin" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 6L16 6" stroke="#B2B8CB" stroke-width="2" stroke-linecap="round"/>
                <path d="M7 13L17 13" stroke="#B2B8CB" stroke-width="2" stroke-linecap="round"/>
                <path d="M9 6H15V9.58579C15 10.4913 15.3597 11.3597 16 12H8C8.64029 11.3597 9 10.4913 9 9.58579V6Z" fill="#B2B8CB"/>
                <path d="M12 13V18" stroke="#B2B8CB" stroke-width="2" stroke-linecap="round"/>
                <rect x="0.5" y="0.5" width="23" height="23" rx="3.5" stroke="#D5DBE5"/>
            </svg>
        </div>

        <div class="navigation-items">
            <navigation-item :i18n="{ id: 'hub_learn' }" route="hub" :active="this.isActiveRoute('hub')" :open="open" v-on:navigate="navigate">
                <template v-slot:icon>
                    <menu-hub-icon />
                </template>
            </navigation-item>

            <navigation-item :i18n="{ id: 'menu_learn' }" route="guess" :active="this.isActiveRoute('guess')" :open="open" v-on:navigate="navigate">
                <template v-slot:icon>
                    <menu-cards-icon />
                </template>
            </navigation-item>

            <navigation-item :i18n="{ id: 'content_navigation_exercises_label' }"
                             :subRoutes="[{ route: 'challenges', i18n: { id: 'menu_challenges' }, active: this.isActiveRoute('challenges'), hidden: !this.challenges_enabled }, { route: 'grammar-tips', i18n: { id: 'menu_grammar_tips' }, active: this.isActiveRoute('grammar-tips'), hidden: !this.grammar_tips_enabled }]"
                             :active="this.isActiveRoute('challenges') || this.isActiveRoute('grammar-tips')"
                             :open="open" v-on:navigate="navigate" v-if="this.challenges_enabled || this.grammar_tips_enabled">
                <template v-slot:icon>
                    <menu-exercises-icon />
                </template>
            </navigation-item>

            <navigation-item v-if="this.cw_enabled" route="course-wizard" :i18n="{ id: 'course-wizard', collection: 'classrooms_nav' }" :active="this.isActiveRoute('course-wizard')" :open="open" v-on:navigate="navigate">
                <template v-slot:icon>
                    <menu-course-wizard-icon />
                </template>
            </navigation-item>

            <navigation-item :i18n="{ id: 'menu_classrooms' }"
                             :subRoutes="[{ route: 'classrooms', i18n: { id: 'classroom', collection: 'classrooms_nav' }, active: this.isActiveRoute('classrooms') }, { route: 'lessons', i18n: { id: 'lessons', collection: 'classrooms_nav' }, active: this.isActiveRoute('lessons') } ]"
                             :active="this.isActiveRoute('classrooms') || this.isActiveRoute('lessons')"
                             :open="open" v-on:navigate="navigate">
                <template v-slot:icon>
                    <menu-classrooms-icon />
                </template>
            </navigation-item>

            <navigation-item :i18n="{ id: 'hub_dashboard' }"
                             :subRoutes="[{ route: 'insights/calendar', i18n: { id: 'dashboard_calendar_card_title' }, active: this.isActiveRoute('insights/calendar') }, { route: 'insights/wordlist', i18n: { id: 'dashboard_wordlist' }, active: this.isActiveRoute('insights/wordlist') }, { route: 'insights/vocabulary', i18n: { id: 'my_progress_vocabulary' }, active: this.isActiveRoute('insights/vocabulary'), hidden: !this.vocabulary_enabled }]"
                             :active="this.isActiveRoute('insights')"
                             :open="open" v-on:navigate="navigate">
                <template v-slot:icon>
                    <menu-insights-icon />
                </template>
            </navigation-item>

            <navigation-item :i18n="{ id: 'menu_account' }" route="account" :active="this.isActiveRoute('account')" :open="open" v-on:navigate="navigate">
                <template v-slot:icon>
                    <menu-account-icon />
                </template>
            </navigation-item>

            <navigation-item v-if="isPayNavVisible" :i18n="{ id: 'hub_subscriptions' }" route="subscriptions" :active="this.isActiveRoute('subscriptions')" :open="open" :notify="gameOver" v-on:navigate="navigate">
                <template v-slot:icon>
                    <menu-pay-icon />
                </template>
            </navigation-item>

            <navigation-item :i18n="{ id: 'menu_help' }" uri="lingvist:help" :open="open" v-on:navigate="navigate">
                <template v-slot:icon>
                    <menu-help-icon />
                </template>
            </navigation-item>

        </div>

    </div>
</template>

<script>
    import Vue from 'vue';
    import AsyncComputed from 'vue-async-computed';
    import { EventBus } from 'Util/vue-event-bus';
    import { COURSE_FEATURE } from 'Modules/course/course.js';
    import { SUBSCRIPTION_STATUS } from 'Modules/subscription.js';
    import MenuHubIcon from 'Images/menu/home.svg';
    import MenuExercisesIcon from 'Images/menu/exercises.svg';
    import MenuCardsIcon from 'Images/menu/cards.svg';
    import MenuCourseWizardIcon from 'Images/menu/lessons-creator.svg';
    import MenuChallengesIcon from 'Images/menu/challenges.svg';
    import MenuGrammarTipsIcon from 'Images/menu/grammar-tips.svg';
    import MenuClassroomsIcon from 'Images/menu/classrooms.svg';
    import MenuAccountIcon from 'Images/menu/account.svg';
    import MenuPayIcon from 'Images/menu/pay.svg';
    import MenuHelpIcon from 'Images/menu/help.svg';
    import MenuInsightsIcon from 'Images/menu/insights.svg';
    import NavigationItem from "./navigation-item.vue";

    Vue.use(AsyncComputed);

    export default {
        name: 'home-drawer.navigation',
        components: {
            NavigationItem,
            MenuHubIcon,
            MenuExercisesIcon,
            MenuCardsIcon,
            MenuCourseWizardIcon,
            MenuChallengesIcon,
            MenuGrammarTipsIcon,
            MenuClassroomsIcon,
            MenuAccountIcon,
            MenuPayIcon,
            MenuHelpIcon,
            MenuInsightsIcon
        },
        props: {
            route: {
                type: String,
                required: true
            },
            open: {
                type: Boolean,
                default: false
            },
            pinned: {
                type: Boolean,
                default: false
            },
            gameOver: {
                type: Boolean,
                default: false
            },
            userCourse: {
                type: Object,
                required: true
            },
            subscriptionInfo: {
                type: Object,
                required: true
            },
            interfaceLanguage: {
                type: String
            },
            isMobile: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            isPayNavVisible() {
                return this.subscriptionInfo && (this.subscriptionInfo.status !== SUBSCRIPTION_STATUS.PAID);
            },
        },
        asyncComputed: {
            async cw_enabled() {
                return this.userCourse.hasFeature(COURSE_FEATURE.COURSE_WIZARD);
            },
            async challenges_enabled() {
                return this.userCourse.hasFeature(COURSE_FEATURE.EXERCISES);
            },
            async grammar_tips_enabled() {
                return this.userCourse.hasFeature(COURSE_FEATURE.GRAMMAR_HINTS);
            },
            async vocabulary_enabled() {
                return this.userCourse.hasFeature(COURSE_FEATURE.VOCABULARY_CURVE);
            }
        },
        methods: {
            home() {
                this.navigate({ route: 'hub', type: 'route' });
            },
            isActiveRoute(r) {
                return (this.route === r || this.route.includes(r));
            },
            togglePinned() {
                this.$emit('togglePinned', !this.pinned)
            },
            navigate(event) {
                const { route, uri, type } = event;
                switch (type) {
                    case 'uri':
                        EventBus.$emit('home-drawer:uri', uri);
                        break;
                    case 'route':
                        EventBus.$emit('home-drawer:navigate', route);
                        break;
                }
            }
        }
    }
</script>

<style lang="scss">
    @import "~Styles/colors";
    @import "~Styles/mixins";

    div.navigation-menu {
        display: flex;
        flex-direction: column;
        gap: 1rem;
        @media all and (max-height: em(700,16)) {
            gap: 0;
        }
        > div.navigation-header {
            display: flex;
            align-items: center;
            flex-direction: row;
            flex-wrap: nowrap;
            gap: pxToRem(10);
            padding: 1.5rem 1rem 1.5rem 1.5rem;
            overflow: hidden;
            direction: ltr;
            width: pxToRem(240);
            body[data-interface-language="ar"] & {
                padding: 1.5rem 1.25rem 1.5rem 1.25rem;
                justify-content: flex-end;
            }
            .fade-enter-active {
                transition: opacity 200ms;
            }
            .fade-enter, .fade-leave, .fade-leave-to {
                opacity: 0;
            }
            > svg.pin {
                margin-left: auto;
                &.pinned {
                    > path {
                        stroke: #2C3143;
                        fill: #2C3143;
                    }
                }
                &:hover {
                    cursor: pointer;
                    transform: scale(1.2);
                }
            }
        }

        > div.navigation-items {
            display: flex;
            flex-direction: column;
            gap: .5rem;
            padding: 0 1rem;
            justify-content: start;
        }
    }
</style>
